import { useMemo } from "react";
import type { EmailLayoutSettings } from "../../../email-design/types/email-layout-type";
import type { LexicalEditorNodes } from "../lexical-editor-wrapper";
import { StylableTableCellMui } from "../nodes/stylable-table-cell-mui";

// Unfortunately a very loose type but better to have a single source.
export type StyleableColumnConfig = Partial<
  Pick<
    EmailLayoutSettings,
    | "column_padding_bottom"
    | "column_padding_left"
    | "column_padding_right"
    | "column_padding_top"
    | "column_individual_padding"
    | "column_padding"
  >
>;

export type TableCellNodeSupercedement = (nodes: LexicalEditorNodes) => LexicalEditorNodes;

type StyleableColumnsFlag =
  | {
      loading: false;
      enabled: boolean;
      tableNodeReplacement: TableCellNodeSupercedement;
    }
  | {
      loading: true;
      enabled: null;
      tableNodeReplacement: TableCellNodeSupercedement;
    };

// if the flag is off, then the editor will have rendered with tablecell nodes.
// Unfortunately we cannot see if one of these has customised properties as lexical
// won't have embedded the data in the standard tablecell node.

// This will replace the tablecellnode with a styleable tablecell quietly, so that
// the type name doesn't change.

export function useStyleableColumns(): StyleableColumnsFlag {
  return useMemo(() => {
    // The loading is handled wrong in useMessageBodyCreator and adds a lot of test mock complexity to fix;
    // given we are removing this and it is on in prod; will hardcord pending full removal
    return {
      loading: false,
      enabled: true,
      tableNodeReplacement: (nodes: LexicalEditorNodes) => {
        const hasTableCellNode = nodes.some(
          (node) => "getType" in node && node.getType() === "tablecell",
        );
        // Only if the channel already allows tablecells and we have the flag enabled
        if (!hasTableCellNode) {
          return nodes;
        }

        const emailNodes = nodes.filter(
          (node) => "getType" in node && node.getType() !== "tablecell",
        );
        return emailNodes.concat(StylableTableCellMui);
      },
    };
  }, []);
}
